module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-bg-1-sp-14fe43666d35ea18cb9709967df934a8.png";